import tinycolor from 'tinycolor2';

import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import { QuestionData, SliderLabelsData } from '@shared/models/survey.model';
import { NgClass } from '@angular/common';
import { BasicModule } from '@shared/modules/basic.module';
import { SharedModuleForPlayer } from '@player/shared/modules/shared.module';
import { LabelOverflow } from '@player/shared/directives/label-overflow.directive';

/**
 * Handles fetching of sharing urls & social shares
 */
@Component({
  selector: 'slider-label',
  templateUrl: './slider-label.component.html',
  styleUrls: ['./slider-label.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgClass, BasicModule, SharedModuleForPlayer, LabelOverflow],
})
export class SliderLabel {
  @Input() sliderLabels: SliderLabelsData;
  @Input() axis?: 'X' | 'Y' | '' = '';
  @Input() data?: QuestionData;
  @Input() color?: string;

  @Input() set shadow(shadow: string) {
    if (this._shadow !== shadow) {
      this.textShadow = shadow && `0 1px 2px ${tinycolor(shadow).setAlpha(0.3).toRgbString()}`;
      this._shadow = shadow;
    }
  }

  @Input() valueSize: number;
  @Input() view?: string;
  @Input() titleSize: number;

  textShadow: string = '';

  private _shadow?: string;
}
